module.exports = __webpack_public_path__ + "img/mstile-150x150.6e19f724.png";